/**
 * Created by stonewang on 2018/2/17.
 */
import React from 'react';
import {hashHistory, withRouter} from 'react-router';
import {Menu} from 'antd';
import '../../App.css';
import '../mallApp.css';

class UserCenter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			viewMenuKey: 'userInfo'
		}
		this.urlChange = this.urlChange.bind(this);
	}
  componentWillUnmount(){
    this.unListen();
	}

	componentDidMount() {
		let routes = this.props.routes;
		this.setState({
			'viewMenuKey': routes[routes.length - 1].path
		});
    this.unListen = this.props.router.listen(this.urlChange)
	}

	urlChange(location) {
    let routes = location.pathname.split('/');
    this.setState({
      'viewMenuKey': routes[routes.length - 1]
    });
	}


	changeViewMenu({item, key, keyPath}) {
		this.setState({viewMenuKey: key}, () => {
			hashHistory.push(`/mallCommon/userCenter/${key}`)
		})
	}

	render() {
		const {viewMenuKey} = this.state;
		return <div>
			<div style={{position: 'relative'}}>
				<Menu className="userCenterMenu"
					  onClick={this.changeViewMenu.bind(this)}
					  selectedKeys={[viewMenuKey]}>
					{/*<Menu.Item key="order">
						<span>我的订单</span>
					</Menu.Item>*/}
					{/* <Menu.Item key="exchange">
						<span>退换货</span>
					</Menu.Item> */}
					{/*<Menu.Item key="message">
						<span>我的消息</span>
					</Menu.Item>*/}
					<Menu.Item key="userInfo">
						<span>个人信息</span>
					</Menu.Item>
					<Menu.Item key="collection">
						<span>我的收藏</span>
					</Menu.Item>
					{/*<Menu.Item key="address">
						<span>收货地址</span>
					</Menu.Item>
					<Menu.Item key="ticket">
						<span>增票资质</span>
					</Menu.Item>*/}
				</Menu>
				<div className="userCenterBody">
					{this.props.children}
				</div>
			</div>
		</div>
	}
}
;
export default withRouter(UserCenter);



// WEBPACK FOOTER //
// ./src/mall/userCenter/index.js